import { el } from "../utils/dom.js";
import { debounce } from "../utils/time.js";
import { store, saveStarred } from "../state/store.js";
import { updateUI } from "./updateUI.js";

export function wireEvents() {
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("button[data-act]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const act = btn.dataset.act;
      const key = btn.dataset.key;
      if (!act) return;

      switch (act) {
        case "toggle_details": {
          if (!key) return;
          const wasOpen = store.openDetails.has(key);
          store.openDetails.clear();
          if (!wasOpen) store.openDetails.add(key);
          updateUI();
          return;
        }

        case "toggle_meta": {
          if (!key) return;
          if (store.openMeta.has(key)) store.openMeta.delete(key);
          else store.openMeta.add(key);
          updateUI();
          return;
        }

        case "toggle_sel": {
          if (!key) return;
          if (store.selection.has(key)) store.selection.delete(key);
          else store.selection.set(key, true);
          updateUI();
          return;
        }

        case "toggle_star": {
          if (!key) return;
          if (store.starred.has(key)) store.starred.delete(key);
          else store.starred.add(key);
          saveStarred();
          updateUI();
          return;
        }

        case "remove": {
          if (!key) return;
          store.selection.delete(key);
          updateUI();
          return;
        }

        case "unstarOwn": {
          if (!key) return;
          store.starred.delete(key);
          saveStarred();
          updateUI();
          return;
        }

        case "select_group": {
          const group = btn.dataset.group;
          if (!group) return;
          document.dispatchEvent(new CustomEvent("favorites:select-group", { detail: { group } }));
          return;
        }

        default:
          return;
      }
    },
    true
  );

  const rerender = debounce(() => updateUI(), 120);
  const search = el("qTp");
  const clearSearch = el("clearSearchBtn");
  const syncClearSearch = () => {
    if (clearSearch) clearSearch.hidden = !search?.value;
  };
  search?.addEventListener("input", syncClearSearch);
  clearSearch?.addEventListener("click", () => {
    if (!search) return;
    search.value = "";
    syncClearSearch();
    updateUI();
    search.focus();
  });
  syncClearSearch();
  el("lnbType")?.addEventListener("change", (event) => {
    store.ui.lnbType = event.target.value;
    updateUI();
    window.dispatchEvent(new Event("app-layoutchange"));
  });
  ["qTp", "satFilter", "sortBy"].forEach((id) => {
    const node = el(id);
    if (!node) return;
    node.addEventListener("input", rerender);
    node.addEventListener("change", rerender);
  });

  el("clearSelBtn")?.addEventListener("click", (e) => {
    e.preventDefault();
    store.selection.clear();
    updateUI();
  });
}
